export default "__VITE_ASSET__d3633df1__"